import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  stationUsageForecast: [],
  loading: false,
  error: null,
};

const stationUsageForecastSlice = createSlice({
  name: "stationUsageForecast",
  initialState,
  reducers: {
    fetchStationUsageForecastSuccess: (state, action) => {
      state.loading = false;
      state.stationUsageForecast = action.payload;
    },
    fetchStationUsageForecastFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchStationUsageForecastSuccess, fetchStationUsageForecastFailure } =
  stationUsageForecastSlice.actions;

export default stationUsageForecastSlice.reducer;
